const getPatientDob1 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Date of Birth'].replace(/[/]/g, '').substring(0, 2);
};

export default getPatientDob1;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientDob1.js